// World Cup 2026 - Programme complet officiel (104 matchs)
// Source: FIFA / roadtrips.com - Calendrier officiel post-tirage au sort (Dec 2025)

// World Cup 2026 Matches - Complete Schedule
export const WC_MATCHES = [
  // Groupe A
  { matchNum: 1, date: "11/06/2026", teams: "Mexique - Afrique du Sud", stage: "Groupe A", venue: "Estadio Azteca", city: "Mexico", time: "15h" },
  { matchNum: 2, date: "11/06/2026", teams: "Corée du Sud - Tchéquie", stage: "Groupe A", venue: "Estadio Akron", city: "Guadalajara", time: "22h" },
  { matchNum: 25, date: "18/06/2026", teams: "Tchéquie - Afrique du Sud", stage: "Groupe A", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "12h" },
  { matchNum: 28, date: "18/06/2026", teams: "Mexique - Corée du Sud", stage: "Groupe A", venue: "Estadio Akron", city: "Guadalajara", time: "21h" },
  { matchNum: 53, date: "24/06/2026", teams: "Tchéquie - Mexique", stage: "Groupe A", venue: "Estadio Azteca", city: "Mexico", time: "21h" },
  { matchNum: 54, date: "24/06/2026", teams: "Afrique du Sud - Corée du Sud", stage: "Groupe A", venue: "Estadio BBVA", city: "Monterrey", time: "21h" },

  // Groupe B
  { matchNum: 3, date: "12/06/2026", teams: "Canada - Bosnie", stage: "Groupe B", venue: "BMO Field", city: "Toronto", time: "15h" },
  { matchNum: 8, date: "13/06/2026", teams: "Qatar - Suisse", stage: "Groupe B", venue: "Levi's Stadium", city: "San Francisco Bay", time: "15h" },
  { matchNum: 26, date: "18/06/2026", teams: "Suisse - Bosnie", stage: "Groupe B", venue: "SoFi Stadium", city: "Los Angeles", time: "15h" },
  { matchNum: 27, date: "18/06/2026", teams: "Canada - Qatar", stage: "Groupe B", venue: "BC Place", city: "Vancouver", time: "18h" },
  { matchNum: 51, date: "24/06/2026", teams: "Suisse - Canada", stage: "Groupe B", venue: "BC Place", city: "Vancouver", time: "15h" },
  { matchNum: 52, date: "24/06/2026", teams: "Bosnie - Qatar", stage: "Groupe B", venue: "Lumen Field", city: "Seattle", time: "15h" },

  // Groupe C
  { matchNum: 7, date: "13/06/2026", teams: "Brésil - Maroc", stage: "Groupe C", venue: "MetLife Stadium", city: "New York/New Jersey", time: "18h" },
  { matchNum: 5, date: "13/06/2026", teams: "Haïti - Écosse", stage: "Groupe C", venue: "Gillette Stadium", city: "Boston", time: "21h" },
  { matchNum: 30, date: "19/06/2026", teams: "Écosse - Maroc", stage: "Groupe C", venue: "Gillette Stadium", city: "Boston", time: "18h" },
  { matchNum: 29, date: "19/06/2026", teams: "Brésil - Haïti", stage: "Groupe C", venue: "Lincoln Financial Field", city: "Philadelphie", time: "21h" },
  { matchNum: 49, date: "24/06/2026", teams: "Écosse - Brésil", stage: "Groupe C", venue: "Hard Rock Stadium", city: "Miami", time: "18h" },
  { matchNum: 50, date: "24/06/2026", teams: "Maroc - Haïti", stage: "Groupe C", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "18h" },

  // Groupe D
  { matchNum: 4, date: "12/06/2026", teams: "États-Unis - Paraguay", stage: "Groupe D", venue: "SoFi Stadium", city: "Los Angeles", time: "21h" },
  { matchNum: 6, date: "13/06/2026", teams: "Australie - Turquie", stage: "Groupe D", venue: "BC Place", city: "Vancouver", time: "00h" },
  { matchNum: 32, date: "19/06/2026", teams: "États-Unis - Australie", stage: "Groupe D", venue: "Lumen Field", city: "Seattle", time: "15h" },
  { matchNum: 31, date: "19/06/2026", teams: "Turquie - Paraguay", stage: "Groupe D", venue: "Levi's Stadium", city: "San Francisco Bay", time: "00h" },
  { matchNum: 59, date: "25/06/2026", teams: "Turquie - États-Unis", stage: "Groupe D", venue: "SoFi Stadium", city: "Los Angeles", time: "22h" },
  { matchNum: 60, date: "25/06/2026", teams: "Paraguay - Australie", stage: "Groupe D", venue: "Levi's Stadium", city: "San Francisco Bay", time: "22h" },

  // Groupe E
  { matchNum: 10, date: "14/06/2026", teams: "Allemagne - Curaçao", stage: "Groupe E", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 9, date: "14/06/2026", teams: "Côte d'Ivoire - Équateur", stage: "Groupe E", venue: "Lincoln Financial Field", city: "Philadelphie", time: "19h" },
  { matchNum: 33, date: "20/06/2026", teams: "Allemagne - Côte d'Ivoire", stage: "Groupe E", venue: "BMO Field", city: "Toronto", time: "16h" },
  { matchNum: 34, date: "20/06/2026", teams: "Équateur - Curaçao", stage: "Groupe E", venue: "Arrowhead Stadium", city: "Kansas City", time: "20h" },
  { matchNum: 56, date: "25/06/2026", teams: "Équateur - Allemagne", stage: "Groupe E", venue: "MetLife Stadium", city: "New York/New Jersey", time: "16h" },
  { matchNum: 55, date: "25/06/2026", teams: "Curaçao - Côte d'Ivoire", stage: "Groupe E", venue: "Lincoln Financial Field", city: "Philadelphie", time: "16h" },

  // Groupe F
  { matchNum: 11, date: "14/06/2026", teams: "Pays-Bas - Japon", stage: "Groupe F", venue: "AT&T Stadium", city: "Dallas", time: "16h" },
  { matchNum: 12, date: "14/06/2026", teams: "Suède - Tunisie", stage: "Groupe F", venue: "Estadio BBVA", city: "Monterrey", time: "22h" },
  { matchNum: 35, date: "20/06/2026", teams: "Pays-Bas - Suède", stage: "Groupe F", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 36, date: "20/06/2026", teams: "Tunisie - Japon", stage: "Groupe F", venue: "Estadio BBVA", city: "Monterrey", time: "00h" },
  { matchNum: 57, date: "25/06/2026", teams: "Japon - Suède", stage: "Groupe F", venue: "AT&T Stadium", city: "Dallas", time: "19h" },
  { matchNum: 58, date: "25/06/2026", teams: "Tunisie - Pays-Bas", stage: "Groupe F", venue: "Arrowhead Stadium", city: "Kansas City", time: "19h" },

  // Groupe G
  { matchNum: 16, date: "15/06/2026", teams: "Belgique - Égypte", stage: "Groupe G", venue: "Lumen Field", city: "Seattle", time: "15h" },
  { matchNum: 15, date: "15/06/2026", teams: "Iran - Nouvelle-Zélande", stage: "Groupe G", venue: "SoFi Stadium", city: "Los Angeles", time: "21h" },
  { matchNum: 39, date: "21/06/2026", teams: "Belgique - Iran", stage: "Groupe G", venue: "SoFi Stadium", city: "Los Angeles", time: "15h" },
  { matchNum: 40, date: "21/06/2026", teams: "Nouvelle-Zélande - Égypte", stage: "Groupe G", venue: "BC Place", city: "Vancouver", time: "21h" },
  { matchNum: 64, date: "26/06/2026", teams: "Nouvelle-Zélande - Belgique", stage: "Groupe G", venue: "BC Place", city: "Vancouver", time: "23h" },
  { matchNum: 63, date: "26/06/2026", teams: "Égypte - Iran", stage: "Groupe G", venue: "Lumen Field", city: "Seattle", time: "23h" },

  // Groupe H
  { matchNum: 14, date: "15/06/2026", teams: "Espagne - Cap-Vert", stage: "Groupe H", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "12h" },
  { matchNum: 13, date: "15/06/2026", teams: "Arabie Saoudite - Uruguay", stage: "Groupe H", venue: "Hard Rock Stadium", city: "Miami", time: "18h" },
  { matchNum: 38, date: "21/06/2026", teams: "Espagne - Arabie Saoudite", stage: "Groupe H", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "12h" },
  { matchNum: 37, date: "21/06/2026", teams: "Uruguay - Cap-Vert", stage: "Groupe H", venue: "Hard Rock Stadium", city: "Miami", time: "18h" },
  { matchNum: 66, date: "26/06/2026", teams: "Uruguay - Espagne", stage: "Groupe H", venue: "Estadio Akron", city: "Guadalajara", time: "20h" },
  { matchNum: 65, date: "26/06/2026", teams: "Cap-Vert - Arabie Saoudite", stage: "Groupe H", venue: "NRG Stadium", city: "Houston", time: "20h" },

  // Groupe I
  { matchNum: 17, date: "16/06/2026", teams: "France - Sénégal", stage: "Groupe I", venue: "MetLife Stadium", city: "New York/New Jersey", time: "15h" },
  { matchNum: 18, date: "16/06/2026", teams: "Irak - Norvège", stage: "Groupe I", venue: "Gillette Stadium", city: "Boston", time: "18h" },
  { matchNum: 42, date: "22/06/2026", teams: "France - Irak", stage: "Groupe I", venue: "Lincoln Financial Field", city: "Philadelphie", time: "17h" },
  { matchNum: 41, date: "22/06/2026", teams: "Norvège - Sénégal", stage: "Groupe I", venue: "MetLife Stadium", city: "New York/New Jersey", time: "20h" },
  { matchNum: 61, date: "26/06/2026", teams: "Norvège - France", stage: "Groupe I", venue: "Gillette Stadium", city: "Boston", time: "15h" },
  { matchNum: 62, date: "26/06/2026", teams: "Sénégal - Irak", stage: "Groupe I", venue: "BMO Field", city: "Toronto", time: "15h" },

  // Groupe J
  { matchNum: 19, date: "16/06/2026", teams: "Argentine - Algérie", stage: "Groupe J", venue: "Arrowhead Stadium", city: "Kansas City", time: "21h" },
  { matchNum: 20, date: "16/06/2026", teams: "Autriche - Jordanie", stage: "Groupe J", venue: "Levi's Stadium", city: "San Francisco Bay", time: "00h" },
  { matchNum: 43, date: "22/06/2026", teams: "Argentine - Autriche", stage: "Groupe J", venue: "AT&T Stadium", city: "Dallas", time: "13h" },
  { matchNum: 44, date: "22/06/2026", teams: "Jordanie - Algérie", stage: "Groupe J", venue: "Levi's Stadium", city: "San Francisco Bay", time: "23h" },
  { matchNum: 70, date: "27/06/2026", teams: "Jordanie - Argentine", stage: "Groupe J", venue: "AT&T Stadium", city: "Dallas", time: "22h" },
  { matchNum: 69, date: "27/06/2026", teams: "Algérie - Autriche", stage: "Groupe J", venue: "Arrowhead Stadium", city: "Kansas City", time: "22h" },

  // Groupe K
  { matchNum: 23, date: "17/06/2026", teams: "Portugal - RD Congo", stage: "Groupe K", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 24, date: "17/06/2026", teams: "Ouzbékistan - Colombie", stage: "Groupe K", venue: "Estadio Azteca", city: "Mexico", time: "22h" },
  { matchNum: 47, date: "23/06/2026", teams: "Portugal - Ouzbékistan", stage: "Groupe K", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 48, date: "23/06/2026", teams: "Colombie - RD Congo", stage: "Groupe K", venue: "Estadio Akron", city: "Guadalajara", time: "22h" },
  { matchNum: 71, date: "27/06/2026", teams: "Colombie - Portugal", stage: "Groupe K", venue: "Hard Rock Stadium", city: "Miami", time: "19h30" },
  { matchNum: 72, date: "27/06/2026", teams: "RD Congo - Ouzbékistan", stage: "Groupe K", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "19h30" },

  // Groupe L
  { matchNum: 22, date: "17/06/2026", teams: "Angleterre - Croatie", stage: "Groupe L", venue: "AT&T Stadium", city: "Dallas", time: "16h" },
  { matchNum: 21, date: "17/06/2026", teams: "Ghana - Panamá", stage: "Groupe L", venue: "BMO Field", city: "Toronto", time: "19h" },
  { matchNum: 45, date: "23/06/2026", teams: "Angleterre - Ghana", stage: "Groupe L", venue: "Gillette Stadium", city: "Boston", time: "16h" },
  { matchNum: 46, date: "23/06/2026", teams: "Panamá - Croatie", stage: "Groupe L", venue: "BMO Field", city: "Toronto", time: "19h" },
  { matchNum: 67, date: "27/06/2026", teams: "Panamá - Angleterre", stage: "Groupe L", venue: "MetLife Stadium", city: "New York/New Jersey", time: "17h" },
  { matchNum: 68, date: "27/06/2026", teams: "Croatie - Ghana", stage: "Groupe L", venue: "Lincoln Financial Field", city: "Philadelphie", time: "17h" },

  // 1/16e de finale (Round of 32) - Matchs 73-88
  { matchNum: 73, date: "28/06/2026", teams: "2e Groupe A - 2e Groupe B", stage: "1/16e", venue: "SoFi Stadium", city: "Los Angeles", time: "15h" },
  { matchNum: 74, date: "29/06/2026", teams: "1er Groupe E - 3e A/B/C/D/F", stage: "1/16e", venue: "Gillette Stadium", city: "Boston", time: "16h30" },
  { matchNum: 75, date: "29/06/2026", teams: "1er Groupe F - 2e Groupe C", stage: "1/16e", venue: "Estadio BBVA", city: "Monterrey", time: "21h" },
  { matchNum: 76, date: "29/06/2026", teams: "1er Groupe C - 2e Groupe F", stage: "1/16e", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 77, date: "30/06/2026", teams: "1er Groupe I - 3e C/D/F/G/H", stage: "1/16e", venue: "MetLife Stadium", city: "New York/New Jersey", time: "17h" },
  { matchNum: 78, date: "30/06/2026", teams: "2e Groupe E - 2e Groupe I", stage: "1/16e", venue: "AT&T Stadium", city: "Dallas", time: "13h" },
  { matchNum: 79, date: "30/06/2026", teams: "1er Groupe A - 3e C/E/F/H/I", stage: "1/16e", venue: "Estadio Azteca", city: "Mexico", time: "21h" },
  { matchNum: 80, date: "01/07/2026", teams: "1er Groupe L - 3e E/H/I/J/K", stage: "1/16e", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "12h" },
  { matchNum: 81, date: "01/07/2026", teams: "1er Groupe D - 3e B/E/F/I/J", stage: "1/16e", venue: "Levi's Stadium", city: "San Francisco Bay", time: "20h" },
  { matchNum: 82, date: "01/07/2026", teams: "1er Groupe G - 3e A/E/H/I/J", stage: "1/16e", venue: "Lumen Field", city: "Seattle", time: "16h" },
  { matchNum: 83, date: "02/07/2026", teams: "2e Groupe K - 2e Groupe L", stage: "1/16e", venue: "BMO Field", city: "Toronto", time: "19h" },
  { matchNum: 84, date: "02/07/2026", teams: "1er Groupe H - 2e Groupe J", stage: "1/16e", venue: "SoFi Stadium", city: "Los Angeles", time: "15h" },
  { matchNum: 85, date: "02/07/2026", teams: "1er Groupe B - 3e E/F/G/I/J", stage: "1/16e", venue: "BC Place", city: "Vancouver", time: "23h" },
  { matchNum: 86, date: "03/07/2026", teams: "1er Groupe J - 2e Groupe H", stage: "1/16e", venue: "Hard Rock Stadium", city: "Miami", time: "18h" },
  { matchNum: 87, date: "03/07/2026", teams: "1er Groupe K - 3e D/E/I/J/L", stage: "1/16e", venue: "Arrowhead Stadium", city: "Kansas City", time: "21h30" },
  { matchNum: 88, date: "03/07/2026", teams: "2e Groupe D - 2e Groupe G", stage: "1/16e", venue: "AT&T Stadium", city: "Dallas", time: "14h" },

  // 1/8e de finale (Round of 16) - Matchs 89-96
  { matchNum: 89, date: "04/07/2026", teams: "Vainqueur 74 - Vainqueur 77", stage: "1/8e", venue: "Lincoln Financial Field", city: "Philadelphie", time: "17h" },
  { matchNum: 90, date: "04/07/2026", teams: "Vainqueur 73 - Vainqueur 75", stage: "1/8e", venue: "NRG Stadium", city: "Houston", time: "13h" },
  { matchNum: 91, date: "05/07/2026", teams: "Vainqueur 76 - Vainqueur 78", stage: "1/8e", venue: "MetLife Stadium", city: "New York/New Jersey", time: "16h" },
  { matchNum: 92, date: "05/07/2026", teams: "Vainqueur 79 - Vainqueur 80", stage: "1/8e", venue: "Estadio Azteca", city: "Mexico", time: "20h" },
  { matchNum: 93, date: "06/07/2026", teams: "Vainqueur 83 - Vainqueur 84", stage: "1/8e", venue: "AT&T Stadium", city: "Dallas", time: "15h" },
  { matchNum: 94, date: "06/07/2026", teams: "Vainqueur 81 - Vainqueur 82", stage: "1/8e", venue: "Lumen Field", city: "Seattle", time: "20h" },
  { matchNum: 95, date: "07/07/2026", teams: "Vainqueur 86 - Vainqueur 88", stage: "1/8e", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "12h" },
  { matchNum: 96, date: "07/07/2026", teams: "Vainqueur 85 - Vainqueur 87", stage: "1/8e", venue: "BC Place", city: "Vancouver", time: "16h" },

  // Quarts de finale - Matchs 97-100
  { matchNum: 97, date: "09/07/2026", teams: "Vainqueur 89 - Vainqueur 90", stage: "Quart", venue: "Gillette Stadium", city: "Boston", time: "16h" },
  { matchNum: 98, date: "10/07/2026", teams: "Vainqueur 93 - Vainqueur 94", stage: "Quart", venue: "SoFi Stadium", city: "Los Angeles", time: "15h" },
  { matchNum: 99, date: "11/07/2026", teams: "Vainqueur 91 - Vainqueur 92", stage: "Quart", venue: "Hard Rock Stadium", city: "Miami", time: "17h" },
  { matchNum: 100, date: "11/07/2026", teams: "Vainqueur 95 - Vainqueur 96", stage: "Quart", venue: "Arrowhead Stadium", city: "Kansas City", time: "21h" },

  // Demi-finales - Matchs 101-102
  { matchNum: 101, date: "14/07/2026", teams: "Vainqueur 97 - Vainqueur 98", stage: "Demi", venue: "AT&T Stadium", city: "Dallas", time: "15h" },
  { matchNum: 102, date: "15/07/2026", teams: "Vainqueur 99 - Vainqueur 100", stage: "Demi", venue: "Mercedes-Benz Stadium", city: "Atlanta", time: "15h" },

  // Match pour la 3e place - Match 103
  { matchNum: 103, date: "18/07/2026", teams: "Perdant 101 - Perdant 102", stage: "Bronze", venue: "Hard Rock Stadium", city: "Miami", time: "17h" },

  // Finale - Match 104
  { matchNum: 104, date: "19/07/2026", teams: "Vainqueur 101 - Vainqueur 102", stage: "Finale", venue: "MetLife Stadium", city: "New York/New Jersey", time: "15h" },
];

// Alias mapping for venues (city -> stadium)
const VENUE_ALIASES = {
  // Mexico
  "stade de mexico": "Estadio Azteca",
  "azteca": "Estadio Azteca",
  "estadio azteca": "Estadio Azteca",
  "mexico city": "Estadio Azteca",
  "mexico": "Estadio Azteca",
  "cdmx": "Estadio Azteca",
  "bbva": "Estadio BBVA",
  "monterrey": "Estadio BBVA",
  "estadio bbva": "Estadio BBVA",
  "estadio bbva bancomer": "Estadio BBVA",
  "akron": "Estadio Akron",
  "guadalajara": "Estadio Akron",
  "estadio akron": "Estadio Akron",
  "chivas": "Estadio Akron",
  
  // USA
  "sofi": "SoFi Stadium",
  "sofi stadium": "SoFi Stadium",
  "los angeles": "SoFi Stadium",
  "la": "SoFi Stadium",
  "inglewood": "SoFi Stadium",
  "metlife": "MetLife Stadium",
  "metlife stadium": "MetLife Stadium",
  "new york": "MetLife Stadium",
  "new york/new jersey": "MetLife Stadium",
  "new jersey": "MetLife Stadium",
  "ny": "MetLife Stadium",
  "nj": "MetLife Stadium",
  "east rutherford": "MetLife Stadium",
  "att": "AT&T Stadium",
  "at&t": "AT&T Stadium",
  "at&t stadium": "AT&T Stadium",
  "dallas": "AT&T Stadium",
  "arlington": "AT&T Stadium",
  "cowboys": "AT&T Stadium",
  "hard rock": "Hard Rock Stadium",
  "hard rock stadium": "Hard Rock Stadium",
  "miami": "Hard Rock Stadium",
  "miami gardens": "Hard Rock Stadium",
  "dolphins": "Hard Rock Stadium",
  "nrg": "NRG Stadium",
  "nrg stadium": "NRG Stadium",
  "houston": "NRG Stadium",
  "texans": "NRG Stadium",
  "mercedes benz": "Mercedes-Benz Stadium",
  "mercedes-benz": "Mercedes-Benz Stadium",
  "mercedes-benz stadium": "Mercedes-Benz Stadium",
  "atlanta": "Mercedes-Benz Stadium",
  "falcons": "Mercedes-Benz Stadium",
  "lincoln": "Lincoln Financial Field",
  "lincoln financial field": "Lincoln Financial Field",
  "philadelphia": "Lincoln Financial Field",
  "philadelphie": "Lincoln Financial Field",
  "philly": "Lincoln Financial Field",
  "eagles": "Lincoln Financial Field",
  "lumen": "Lumen Field",
  "lumen field": "Lumen Field",
  "seattle": "Lumen Field",
  "centurylink": "Lumen Field",
  "seahawks": "Lumen Field",
  "levis": "Levi's Stadium",
  "levi's": "Levi's Stadium",
  "levi's stadium": "Levi's Stadium",
  "san francisco": "Levi's Stadium",
  "san francisco bay": "Levi's Stadium",
  "sf": "Levi's Stadium",
  "santa clara": "Levi's Stadium",
  "49ers": "Levi's Stadium",
  "arrowhead": "Arrowhead Stadium",
  "arrowhead stadium": "Arrowhead Stadium",
  "kansas city": "Arrowhead Stadium",
  "kc": "Arrowhead Stadium",
  "chiefs": "Arrowhead Stadium",
  "geha field": "Arrowhead Stadium",
  "gillette": "Gillette Stadium",
  "gillette stadium": "Gillette Stadium",
  "boston": "Gillette Stadium",
  "foxborough": "Gillette Stadium",
  "foxboro": "Gillette Stadium",
  "patriots": "Gillette Stadium",
  
  // Canada
  "bmo": "BMO Field",
  "bmo field": "BMO Field",
  "toronto": "BMO Field",
  "bc place": "BC Place",
  "vancouver": "BC Place",
};

// Stage aliases (French + English + abbreviations)
const STAGE_ALIASES = {
  "group a": "Groupe A", "groupe a": "Groupe A", "ga": "Groupe A",
  "group b": "Groupe B", "groupe b": "Groupe B", "gb": "Groupe B",
  "group c": "Groupe C", "groupe c": "Groupe C", "gc": "Groupe C",
  "group d": "Groupe D", "groupe d": "Groupe D", "gd": "Groupe D",
  "group e": "Groupe E", "groupe e": "Groupe E", "ge": "Groupe E",
  "group f": "Groupe F", "groupe f": "Groupe F", "gf": "Groupe F",
  "group g": "Groupe G", "groupe g": "Groupe G", "gg": "Groupe G",
  "group h": "Groupe H", "groupe h": "Groupe H", "gh": "Groupe H",
  "group i": "Groupe I", "groupe i": "Groupe I", "gi": "Groupe I",
  "group j": "Groupe J", "groupe j": "Groupe J", "gj": "Groupe J",
  "group k": "Groupe K", "groupe k": "Groupe K", "gk": "Groupe K",
  "group l": "Groupe L", "groupe l": "Groupe L", "gl": "Groupe L",
  "1/16": "1/16e", "1/16e": "1/16e", "r32": "1/16e", "round 32": "1/16e", "round of 32": "1/16e",
  "32eme": "1/16e", "32èmes": "1/16e", "seizieme": "1/16e", "seizièmes": "1/16e",
  "1/8": "1/8e", "1/8e": "1/8e", "r16": "1/8e", "round 16": "1/8e", "round of 16": "1/8e",
  "16eme": "1/8e", "16èmes": "1/8e", "huitieme": "1/8e", "huitièmes": "1/8e",
  "qf": "Quart", "quart": "Quart", "quarter": "Quart", "quarterfinal": "Quart",
  "quarts": "Quart", "quart de finale": "Quart", "quarts de finale": "Quart",
  "sf": "Demi", "semi": "Demi", "demi": "Demi", "semifinal": "Demi",
  "demis": "Demi", "demi-finale": "Demi", "demi finale": "Demi",
  "3rd": "Bronze", "third": "Bronze", "3eme": "Bronze", "bronze": "Bronze",
  "petite finale": "Bronze", "3e place": "Bronze", "troisieme place": "Bronze",
  "final": "Finale", "finale": "Finale", "f": "Finale",
};

/**
 * Normalize match number from various formats
 * Examples: "057", "M57", "match 57", "57" -> 57
 */
export const normalizeMatchNumber = (input) => {
  if (!input) return null;
  const str = String(input).trim().toLowerCase();
  
  const patterns = [
    /^m?0*(\d{1,3})$/i,          // M57, 057, 57, M074
    /^match\s*(\d{1,3})$/i,      // match 57
    /^game\s*(\d{1,3})$/i,       // game 57
    /^partido\s*(\d{1,3})$/i,    // partido 57
    /^#(\d{1,3})$/i,             // #57
  ];
  
  for (const pattern of patterns) {
    const match = str.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 1 && num <= 104) return num;
    }
  }
  
  // Direct number
  const directNum = parseInt(str, 10);
  if (!isNaN(directNum) && directNum >= 1 && directNum <= 104) {
    return directNum;
  }
  
  return null;
};

/**
 * Get match by match number
 */
export const getMatchByNumber = (matchNum) => {
  const num = typeof matchNum === 'number' ? matchNum : normalizeMatchNumber(matchNum);
  if (!num) return null;
  return WC_MATCHES.find(m => m.matchNum === num);
};

/**
 * Normalize venue name from alias
 */
export const normalizeVenue = (input) => {
  if (!input) return null;
  const normalized = input.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return VENUE_ALIASES[normalized] || input;
};

/**
 * Normalize stage/phase name from alias
 */
export const normalizeStage = (input) => {
  if (!input) return null;
  const normalized = input.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return STAGE_ALIASES[normalized] || input;
};

/**
 * Generate full match name for display
 * Example: "M7 Brésil - Maroc - Groupe C - New York/New Jersey"
 */
export const getMatchDisplayName = (matchNum) => {
  const match = getMatchByNumber(matchNum);
  if (!match) return null;
  return `M${match.matchNum} ${match.teams} - ${match.stage} - ${match.city}`;
};

/**
 * Normalize World Cup ticket data during import
 */
export const normalizeWCTicket = (ticket) => {
  const result = { ...ticket };
  
  let matchNum = null;
  
  const matchFields = ['match', 'match_num', 'matchnum', 'numero_match', 'evenement', 'event', 'ref'];
  for (const field of matchFields) {
    if (ticket[field]) {
      matchNum = normalizeMatchNumber(ticket[field]);
      if (matchNum) break;
    }
  }
  
  if (matchNum) {
    const match = getMatchByNumber(matchNum);
    if (match) {
      result.evenement = result.evenement || getMatchDisplayName(matchNum);
      result.date_evenement = result.date_evenement || match.date;
      result.lieu = result.lieu || match.venue;
      result.ville = result.ville || match.city;
      result.phase = result.phase || match.stage;
      result.match_num = matchNum;
    }
  }
  
  if (result.lieu) {
    result.lieu = normalizeVenue(result.lieu);
  }
  
  if (result.phase) {
    result.phase = normalizeStage(result.phase);
  }
  
  return result;
};

/**
 * Smart detect match from partial data
 */
export const detectMatchFromText = (input) => {
  if (!input) return null;
  const str = String(input).trim();
  
  const matchNum = normalizeMatchNumber(str);
  if (matchNum) {
    return getMatchByNumber(matchNum);
  }
  
  const patterns = [
    /m(\d{1,3})/i,
    /match\s*(\d{1,3})/i,
    /\b(\d{1,3})\b/,
  ];
  
  for (const pattern of patterns) {
    const match = str.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 1 && num <= 104) {
        return getMatchByNumber(num);
      }
    }
  }
  
  return null;
};

export default {
  WC_MATCHES,
  normalizeMatchNumber,
  getMatchByNumber,
  normalizeVenue,
  normalizeStage,
  getMatchDisplayName,
  normalizeWCTicket,
  detectMatchFromText,
};
